module.exports = __webpack_public_path__ + "img/kefu.ac68322f.png";